module.exports = __webpack_public_path__ + "static/media/recibi.b0f27c80.gif";